import React from "react"

import withStyles from "@material-ui/core/styles/withStyles"
import loginStyle from "../../assets/css/layout/loginStyle"
import Button from "../../components/CustomButtons/Button"
import Card from "../../components/Card/Card"
import CardHeader from "../../components/Card/CardHeader"
import CardBody from "../../components/Card/CardBody"
import Grid from "@material-ui/core/Grid"
import GridContainer from "../../components/Grid/GridContainer"
import { Typography, TextField } from "@material-ui/core"
import {
    showNotification,
    showWaiting,
    hideWaiting,
    mapErrors
} from "../../util/Constants"
import { CNIPTU } from "../../util/imovel"


export class CNIPTUContribuinte extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {},
            documento: "",
            show: false,
            imoveis: [],
            imovel_id: {}
        }
        this.handleChange = this.handleChange.bind(this)
        this.imprimir = this.imprimir.bind(this)
    }
    toggleLoad() {
        this.setState(state => ({
            isLoading: !state.isLoading
        }))
    }

    handleChange(event) {
        let name = event.target.name
        let errors = this.state.errors
        errors[name] = undefined
        this.setState({
            [name]: event.target.value,
            errors: errors
        }, () => {

        })
    }

    imprimir() {
        showWaiting()
        CNIPTU(this.state.inscricao, (error, data) => {
            hideWaiting()
            if (error) {
                const reader = new FileReader()
                reader.addEventListener("loadend", e => {
                    const text = e.srcElement.result
                    let a = JSON.parse(text)
                    try {
                        if(a.errors !== undefined) {
                            showNotification("top", "center", a.errors.imovel_id[0], "warning")
                        } else {
                        let error = JSON.parse(text)
                        showNotification("top", "center", error.message, "warning")
                        
                        }
                    } catch (e) {
                        showNotification(
                            "top",
                            "center",
                            "Ocorreram erros, verifique sua conexão com a internet",
                            "danger"
                        )
                    }
                })

                reader.readAsText(error.response.data)
            } else {
                var url = URL.createObjectURL(data)
                let tempLink = document.createElement("a")
                tempLink.setAttribute("target", "_blank")
                tempLink.setAttribute("href", `${url}`)
                tempLink.setAttribute("style", "display:none;")
                document.body.appendChild(tempLink)
                tempLink.click()
                document.body.removeChild(tempLink)

            }

        })
    }
    render() {
        const { classes } = this.props
        return (
            <div className={classes.content}>
                <div className={classes.background} />
                <div>
                    <form>
                        <GridContainer alignItems="center" justify="center">
                            <Grid item xs={12} sm={12} md={8} lg={8}>
                                <Card>
                                    <CardHeader className={classes.textCenter} color="primary">
                                        <h2 className={classes.cardTitleWhite}>
                                            Emitir Certidão Negativa  de IPTU
                                        </h2>
                                        <h4 className={classes.cardTitleWhite}>
                                            Insira seu Imovel
                                        </h4>
                                    </CardHeader>
                                    <CardBody>
                                        <Grid container spacing={16} alignItems="center">
                                            <Grid item xs={12} sm={12} md={8} lg={9} xl={10}>
                                                <TextField
                                                    id="outlined-name"
                                                    label="Insira a inscrição do seu Imóvel"
                                                    fullWidth
                                                    name="inscricao"
                                                    type="text"
                                                    onChange={this.handleChange}
                                                    error={this.state.errors.inscricao}
                                                    helperText={this.state.errors.inscricao}
                                                    value={this.state.inscricao}
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={12} md={4} lg={3} xl={2}>
                                                <Button onClick={this.imprimir} color="info" fullWidth>
                                                    Procurar e imprimir
                                                </Button>
                                            </Grid>
                                        </Grid>
                                        <Typography variant="caption" color="error">
                                            Para o funcionamento correto desta ferramenta, é recomendado que você desabilite o AdBlocker do seu navegador.
                                                    </Typography>
                                    </CardBody>
                                </Card>
                            </Grid>
                        </GridContainer>
                    </form>
                </div>
            </div>
        )
    }
}

export default withStyles(loginStyle)(CNIPTUContribuinte)
